/**
 * Phase 1.7 — Settings route group layout.
 *
 * Renders the SubSidebar on the left and the matched child route on the
 * right. The Phase 1.8 SSO settings page (`/settings/identities`) becomes
 * one of three entries here; the others are placeholder shells that
 * Phase 1.10+ fills in.
 */

import { KeyRound, User, Bell } from 'lucide-react';
import { Outlet } from 'react-router-dom';
import { SubSidebar, type SubSidebarItem } from '@/components/v2/layout/SubSidebar';
import { usePageHeader } from '@/components/v2/layout/Header';

const SETTINGS_NAV: SubSidebarItem[] = [
  { label: 'Profile', href: '/settings/profile', icon: User, description: 'Your name, email, and ranch.' },
  {
    label: 'Linked sign-in methods',
    href: '/settings/identities',
    icon: KeyRound,
    description: 'Microsoft, Google, Cloudflare, Apple, password.',
  },
  {
    label: 'Notifications',
    href: '/settings/notifications',
    icon: Bell,
    description: 'Email + in-app alerts.',
  },
];

export function SettingsLayout(): JSX.Element {
  usePageHeader('Settings');
  return (
    <div className="flex flex-col lg:flex-row lg:items-stretch lg:gap-0 -mx-4 -my-6 md:-mx-8 md:-my-8 min-h-[calc(100vh-3.5rem)]">
      <SubSidebar title="Settings" items={SETTINGS_NAV} />
      <div className="min-w-0 flex-1 px-4 py-6 md:px-8 md:py-8">
        <Outlet />
      </div>
    </div>
  );
}
